export default __webpack_public_path__ + "static/media/main_gif.bb3df659.gif";